export default __webpack_public_path__ + "static/vukasin-60e600ef38c0727665d00fe34e7adc2f.webp";